import { useEffect, useState } from 'react';

import { logError } from 'apps/auth/helpers/clientLogger';

interface StorySlide {
    web_a_bg_img_url?: string;
    web_a2x_bg_img_url?: string;
}

const usePreloadStoryImages = (slides?: StorySlide[]): boolean => {
    const [imagesLoaded, setImagesLoaded] = useState(false);

    useEffect(() => {
        if (!slides || slides.length === 0 || typeof window === 'undefined') {
            return;
        }

        const imagesA = slides.map((slide) => slide.web_a_bg_img_url).filter(Boolean) as string[];
        const imagesA2x = slides.map((slide) => slide.web_a2x_bg_img_url).filter(Boolean) as string[];
        const allImages = [...imagesA, ...imagesA2x];

        if (allImages.length === 0) {
            setImagesLoaded(true);
            return;
        }

        let loadedCount = 0;
        const totalImages = allImages.length;

        const setImgLoaded = (): void => {
            loadedCount += 1;
            if (loadedCount === totalImages) {
                setImagesLoaded(true);
            }
        };

        const imageElements = allImages.map((url) => {
            const img = new Image();
            img.src = url;
            img.onload = setImgLoaded;
            img.onerror = () => {
                setImgLoaded();
                logError(`Image failed to load: ${url}`);
            };
            return img;
        });

        return () => {
            imageElements.forEach((img) => {
                img.onload = null;
                img.onerror = null;
            });
        };
    }, [slides]);

    return imagesLoaded;
};

export default usePreloadStoryImages;
